import script from "./SingleLineText.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleLineText.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__